'use strict';

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startsWith = require('core-js/library/fn/string/starts-with');

var KeyBuilder = require('./Keys');

var _require = require('../utils/key/factory'),
    matching = _require.matching;

var KeyBuilderForLocalStorage = function (_KeyBuilder) {
  (0, _inherits3.default)(KeyBuilderForLocalStorage, _KeyBuilder);

  function KeyBuilderForLocalStorage() {
    (0, _classCallCheck3.default)(this, KeyBuilderForLocalStorage);
    return (0, _possibleConstructorReturn3.default)(this, (KeyBuilderForLocalStorage.__proto__ || (0, _getPrototypeOf2.default)(KeyBuilderForLocalStorage)).apply(this, arguments));
  }

  (0, _createClass3.default)(KeyBuilderForLocalStorage, [{
    key: 'buildSegmentNameKey',
    value: function buildSegmentNameKey(segmentName) {
      return matching(this.settings.core.key) + '.' + this.settings.storage.prefix + '.segment.' + segmentName;
    }
  }, {
    key: 'extractSegmentName',
    value: function extractSegmentName(builtSegmentKeyName) {
      var prefix = matching(this.settings.core.key) + '.' + this.settings.storage.prefix + '.segment.';

      if (startsWith(builtSegmentKeyName, prefix)) return builtSegmentKeyName.substr(prefix.length);
    }
  }]);
  return KeyBuilderForLocalStorage;
}(KeyBuilder);

module.exports = KeyBuilderForLocalStorage;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/storage/KeysLocalStorage.js
// module id = 722
// module chunks = 10